import Vue from "vue";
import VueflatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "@core/scss/vue/libs/vue-flatpicker.scss";

Vue.use(VueflatPickr);
